var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53015 6.7998C1.53015 4.73741 1.53015 3.70621 2.17085 3.06551C2.81156 2.4248 3.84275 2.4248 5.90515 2.4248H8.09265C10.155 2.4248 11.1863 2.4248 11.8269 3.06551C12.4677 3.70621 12.4677 4.73741 12.4677 6.7998C12.4677 8.86218 12.4677 9.89342 11.8269 10.5341C11.1863 11.1748 10.155 11.1748 8.09265 11.1748H5.90515C3.84275 11.1748 2.81156 11.1748 2.17085 10.5341C1.53015 9.89342 1.53015 8.86218 1.53015 6.7998Z",
    stroke: "#1B1F3C",
    strokeWidth: 0.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72021 4.6123L4.90086 5.59618C5.90527 6.43318 6.4075 6.8517 7.00147 6.8517C7.59543 6.8517 8.09768 6.43318 9.10207 5.59618L10.2827 4.6123",
    stroke: "#1B1F3C",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.3088c2f631caf1aa4e567a323ed1a5f4.svg";
export { ForwardRef as ReactComponent };